"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelSubmitWebBlConsigneeCertification = cancelSubmitWebBlConsigneeCertification;
exports.deletehWebBlConsigneeCertification = deletehWebBlConsigneeCertification;
exports.getExportHistory = getExportHistory;
exports.loadBookingHeadWebInitProps = loadBookingHeadWebInitProps;
exports.saveWebBlConsigneeCertification = saveWebBlConsigneeCertification;
exports.searchVoyage = searchVoyage;
exports.searchWebBlConsigneeCertification = searchWebBlConsigneeCertification;
exports.submithWebBlConsigneeCertification = submithWebBlConsigneeCertification;
exports.svlVoyagePlan2queryList = svlVoyagePlan2queryList;
var _request = _interopRequireDefault(require("@/utils/request"));
function svlVoyagePlan2queryList(data) {
  return (0, _request.default)({
    url: '/ebusiness/svlVoyagePlan2/queryList',
    // url: '/webBlConsigneeCertification/add',
    method: 'get',
    params: data
  });
}

//查看挂港 POL lane
function searchVoyage(data) {
  return (0, _request.default)({
    url: '/ebusiness/svlVoyagePlan2/loadVoyagePlan3',
    method: 'get',
    params: data
  });
}
function getExportHistory(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHead/exportHistory',
    // url: '/webBlConsigneeCertification/add',
    method: 'post',
    responseType: 'blob',
    data: data
  });
}
function loadBookingHeadWebInitProps(id) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHead/loadBookingHeadWebInitProps/' + id,
    // url: '/webBlConsigneeCertification/add',
    method: 'get'
  });
}
function searchWebBlConsigneeCertification(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBlConsigneeCertification/search',
    // url: '/webBlConsigneeCertification/search',
    method: 'get',
    params: data
  });
}
function deletehWebBlConsigneeCertification(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBlConsigneeCertification/deleteBatch',
    // url: '/webBlConsigneeCertification/deleteBatch',
    method: 'post',
    data: data
  });
}
function saveWebBlConsigneeCertification(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBlConsigneeCertification/edit',
    // url: '/webBlConsigneeCertification/edit',
    method: 'post',
    data: data
  });
}
function submithWebBlConsigneeCertification(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBlConsigneeCertification/submit',
    // url: '/webBlConsigneeCertification/submit',
    method: 'post',
    data: data
  });
}
function cancelSubmitWebBlConsigneeCertification(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBlConsigneeCertification/cancelSubmit',
    // url: '/webBlConsigneeCertification/cancelSubmit',
    method: 'post',
    data: data
  });
}